import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { UserCompactInfo } from '../../../../models/user/user-compact-info.model';
import { DateTimeHelper } from '../../../../utils/DateTimeHelper.util';
import { StateTypes } from '../../../../common/enums';
import { namespace } from 'vuex-class';
import { TICKET_MODULE_NAMESPACE } from '../../../../store/ticket';
import { ITicketChannel, ITicketListingViewModel } from '../../../../models/ticket';
import * as _ from "lodash";

const TicketStore = namespace(TICKET_MODULE_NAMESPACE)

@Component({
  components: {
    'message-time-notif-status': async () => import('../ticket-chat-message-time-notif-status/TicketChatMessageTimeNotifStatus.vue')
  }
})
class TicketChatMessageRequestQuoteItem extends Vue {


  dtIcons: {
    [prop: string]: string
  }
  @Prop({ required: true, type: [Object] })
  source: any;

  @Prop({ required: true, type: [Boolean] })
  isOwner: any;


  @TicketStore.Getter currentChannel: ITicketChannel;
  @TicketStore.Getter currentTicket: ITicketListingViewModel;

  /**
   *
   */
  constructor() {
    super();
    this.dtIcons = {
      quote_request: 'icon-arrow-right',
      mandate_request: 'icon-flag',
      open: 'icon-flag',
      reopen: 'icon-flag',
      intervention_report: 'icon-flag',
      join: 'icon-flag',
      close: 'icon-cross-bold',
      ask_appointment: 'alarm_on',
      confirm_appointment: 'alarm_on',
      reject_appointment: 'alarm_on',
      cancel_appointment: 'alarm_on',
      done_appointment: 'alarm_on',
      update_appointment: 'alarm_on',
      scheduled_appointment: 'alarm_on',
      join_channel: 'icon-flag',
      new_group: 'icon-flag',
      quit_channel: 'icon-flag',
      remove_ic: 'icon-flag',
      close_channel: 'icon-flag',
      reopen_channel: 'icon-flag',
      update_ticket: 'icon-flag'
    }
  }

  get lblSetting(): { [prop: string]: string } {
    return {
      ...require('@/locales/generic-labels').default,
      ...require('@/locales/ticket').default
    }
  }

  get coDynamicDataTranslation() {
    /** Get actor full name and type */
    const data: { name?: string, authoName?: string, date?: string, time?: string, creator?: string } = {};
    const type: string = this.source.action_type;
    if (type === StateTypes.MandateRequest || type === StateTypes.QuoteRequest || type === StateTypes.RemoveIc) {
      data.creator = [this.source.actor.entity.firstname, this.source.actor.entity.lastname].join(' ')
      const entity = new UserCompactInfo(this.source.concern_actor.entity)
      //data.name = `${entity.typeOfEntity} ${entity.fullName}`
      data.name = `${entity.fullName}`
    } else if (type === 'new_group') {
      const names: string[] = this.currentChannel.participants.map(x => `${x.entity!.firstname} ${x.entity!.lastname}`)
      data.name = names.join(',').replace(`,${names[names.length - 1]}`, '');
      data['latestname'] = names[names.length - 1]
    } else if (type) {
      const entity = new UserCompactInfo(this.source.actor.entity)
      data.name = entity.fullName || ''
    }

    /** Get apppointment date time */
    if (this.coIcon === 'alarm_on') {
      if (this.source.appointment_actions && this.source.appointment_actions.appointment) {
        data.date = DateTimeHelper.parseDate(this.source.appointment_actions.appointment.start_date)
        data.time = DateTimeHelper.parseTime(this.source.appointment_actions.appointment.start_date)
        if (type === StateTypes.AppoinmentUpdate) {
          data['endDate'] = DateTimeHelper.parseDate(this.source.appointment_actions.appointment.end_date)
          data['endTime'] = DateTimeHelper.parseTime(this.source.appointment_actions.appointment.end_date)
        }
      }
    }

    return data;
  }


  get coIcon(): string {
    return this.dtIcons[this.source.action_type];
  }

  get coTime(): string {
    return DateTimeHelper.parseTimeWithoutUtc(this.source.createdAt);
  }

  get isOpen(): boolean {
    return this.source.action_type === StateTypes.Open
  }


}

export default TicketChatMessageRequestQuoteItem;



// WEBPACK FOOTER //
// ./src/containers/ticket/components/ticket-chat-message-request-quote-item/index.ts